import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../../shared/ErrorHandler';
import { UserService } from '../../../../shared/user.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-stateform',
  templateUrl: './stateform.component.html',
  styleUrls: ['./stateform.component.css']
})
export class StateformComponent implements OnInit {
title =  'State Details';
data : any = {};
formInvalid : boolean = false;
d : any = {};
fileToUpload: File = null;

ST_Id : number;
mode : string;

Active: any=[];

photoImageUrl: any;
AS_Photo: string;
Activespili: any=[];
constructor(public service : UserService,private router: Router,private route: ActivatedRoute,  private errorHandler: ErrorHandler) { }

ngOnInit() {


  this.route.params.subscribe(params => {
    this.ST_Id = params['ST_Id'];
    this.mode  =   params['mode'];

      if(this.ST_Id > 0){
        this.getbyid(this.ST_Id)
      }

  });

  if(this.mode=='view'){
    this.title = "View State";
  }
  else if(this.mode=='edit'){
    this.title = "Edit State";
  }

}
SaveDistrict(Distict: NgForm){

  if(Distict.invalid)
  {
    this.formInvalid = true;
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }

  else{
          this.data = this.service.Poststate(Distict.value);
          this.data.subscribe(
          (response) => {
            Distict.reset();
            Distict.resetForm();
            Distict.form.markAsPristine();
            Distict.form.markAsUntouched();
            swal('Success!', 'State Added Successfully .', 'success');
            this.router.navigate(['/home/state']) ;
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });


  }
}


UpdateDistrict(District: NgForm) {
  this.data = this.service.updatestate(District.value,this.ST_Id);
 this.data.subscribe(
   (response) => {
    District.reset();
    District.resetForm();
    District.form.markAsPristine();
    District.form.markAsUntouched();

     swal('Success!', 'State updated Successfully .', 'success');

     this.router.navigate(['/home/state']) ;
     document.getElementById('loader-spinner').style.display = "none";
   }, (error) => {
     document.getElementById('loader-spinner').style.display = "none";
     if (error.status == 401) {
       this.errorHandler.HandlerError(error);
     }
     else if (error.status == 400) {
      swal('Warning!', error.error.Message, 'warning');
     }
   });
}

Cancel(){
//this.router.navigate(['/menu/master']) ;
this.d.district_name='';
this.d.district_id='';
}
 getbyid(ST_Id) {
          {


            document.getElementById('loader-spinner').style.display = "block";
            this.data = this.service.getbyState(ST_Id);
            this.data.subscribe(
              (response: any) => {
              this.d = response;



           document.getElementById('loader-spinner').style.display = "none";
              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
              });
          }

        }

}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/state/stateform/stateform.component.ts